import styled, { keyframes } from 'styled-components'

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const ChatIconButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #0cc18c 0%, #0aa87a 100%);
  border: none;
  border-radius: 50%;
  box-shadow: 0 4px 12px rgba(12, 193, 140, 0.4);
  cursor: pointer;
  z-index: 9999;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(12, 193, 140, 0.5);
  }

  &:focus {
    outline: none;
  }
`

export const NotificationContainer = styled.div`
  position: fixed;
  bottom: 90px;
  right: 20px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  padding: 20px;
  max-width: 340px;
  z-index: 10000;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  animation: ${slideUp} 0.3s ease-out;
`

export const NotificationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 12px;
`

export const NotificationTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const IconCircle = styled.div`
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #0cc18c 0%, #0aa87a 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TitleText = styled.strong`
  color: #333;
  font-size: 16px;
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  color: #999;
  line-height: 1;
  margin-left: 8px;
  transition: color 0.2s;

  &:hover {
    color: #666;
  }

  &:focus {
    outline: none;
  }
`

export const NotificationMessage = styled.p`
  margin: 0 0 16px 0;
  color: #666;
`

export const SupportLink = styled.a`
  display: block;
  width: fit-content;
  margin: 0 auto;
  background: linear-gradient(135deg, #0cc18c 0%, #0aa87a 100%);
  color: white;
  text-decoration: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(12, 193, 140, 0.3);
  text-align: center;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(12, 193, 140, 0.4);
    color: white;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(12, 193, 140, 0.2);
  }
`
